<script lang="ts">
	import navigation from '../plugins/routes'
	import { path as currentPath } from '../store/navigation'
</script>

<ul class="app-navigation hidden md:flex">
	{#each navigation as { name, path }, i}
		<li>
			<a class="block p-4"
			  class:font-semibold="{$currentPath === path}"
			  href={path}
			>
				{name}
			</a>
		</li>
	{/each}
</ul>